import YPageBuilderGridCell from './GridCell';

export { YPageBuilderGridCell };
export default YPageBuilderGridCell;
